import { event, GtagEvent } from "./event";

export interface VirtualCurrencyName extends GtagEvent {
    virtual_currency_name:string;
    value: number;
}
export const earn_virtual_currency = ($_:VirtualCurrencyName) => event('earn_virtual_currency',$_);